import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'rt-interview-result-summary-overall-hidden-evaluations-gauge-chart',
  templateUrl: 'interview-result-summary-overall-hidden-evaluations-gauge-chart.component.html',
  styleUrls: ['./interview-result-summary-overall-hidden-evaluations-gauge-chart.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class InterviewResultSummaryOverallHiddenEvaluationsGaugeChartComponent {}
